export default "__VITE_ASSET__D4Z5Q43R__"